import React from 'react';

function PlayerScorePanel({ player, isMobile = false }) {
    const { score = 0, bonusStrings = [] } = player;

    return (
        <div style={{
            backgroundColor: '#f8f9fa',
            border: '2px solid #ddd',
            borderRadius: '8px',
            padding: isMobile ? '15px' : '20px',
            minHeight: isMobile ? '150px' : '200px',
            maxHeight: isMobile ? '400px' : '400px',
            width: '140%',
            maxWidth: isMobile ? '100%' : '275px',
            boxSizing: 'border-box'
        }}>
            <h4 style={{
                margin: '0 0 15px 0',
                color: '#2c3e50',
                borderBottom: '2px solid #ecf0f1',
                paddingBottom: '8px',
                fontSize: isMobile ? '16px' : '18px'
            }}>
                Score Breakdown
            </h4>

            <div style={{
                fontSize: isMobile ? '20px' : '24px',
                fontWeight: 'bold',
                color: '#27ae60',
                marginBottom: isMobile ? '15px' : '20px',
                textAlign: 'center',
                padding: isMobile ? '10px' : '15px',
                backgroundColor: '#ffffff',
                border: '2px solid #27ae60',
                borderRadius: '8px'
            }}>
                Total: {score}PT
            </div>

            {bonusStrings.length > 0 ? (
                <div>
                    <h5 style={{
                        margin: '0 0 10px 0',
                        color: '#34495e',
                        fontSize: isMobile ? '14px' : '16px'
                    }}>
                        Scoring Details:
                    </h5>
                    <div style={{
                        maxHeight: isMobile ? '150px' : '200px',
                        overflowY: 'auto'
                    }}>
                        {bonusStrings.map((bonus, index) => (
                            <div
                                key={index}
                                style={{
                                    padding: isMobile ? '6px' : '8px',
                                    margin: '4px 0',
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #ecf0f1',
                                    borderRadius: '4px',
                                    fontSize: isMobile ? '11px' : '13px',
                                    borderLeft: '4px solid #3498db',
                                    wordWrap: 'break-word'
                                }}
                            >
                                {bonus}
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div style={{
                    textAlign: 'center',
                    color: '#7f8c8d',
                    fontStyle: 'italic',
                    padding: isMobile ? '20px 0' : '30px 0',
                    fontSize: isMobile ? '14px' : '16px'
                }}>
                    No scoring details available
                </div>
            )}
        </div>
    );
}

export default PlayerScorePanel;
